import promotion from '@resources/js/components/promotion'
import initJSLinks from '@resources/js/js-links'
import Modal from '@resources/js/ui/Modal'
import { initShareBtn } from '@resources/js/helpers/initShareBtn'
import { initSwiper } from '@resources/js/components/initSwiper.js'
import { findHtmlElement } from '@resources/js/helpers/dom.js'
import inViewport from '@resources/js/helpers/inViewport'
import Toggle from '@resources/js/ui/Toggle'
import { renderCategorySliders } from '@resources/js/widgets/from-parsed-page/category-sliders/category-sliders_1'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import '@resources/js/analytics'

const partnerType = getBcomOrExpediaPartnerType()

promotion({
	links: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
	backbtn: {
		active: !!shared.options.bbcl && !!shared.options.dest_id,
		type: partnerType,
	},
	tab_change: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
	popup: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
})

// Social networks popup
new Modal('.js-networks-popup', { trigger: '.js-networks', lockScroll: false })

// Share button
const shareBtn = document.querySelector('.js-share-btn')
initShareBtn(shareBtn)

initJSLinks()

//swiper logic
const swiperContainerElements = document.querySelectorAll('.js-slider-container')

if (swiperContainerElements.length) {
	swiperContainerElements.forEach(swiperContainerElement => {
		inViewport(swiperContainerElement, () => {
			const swiperElement = findHtmlElement(
				'.js-slider',
				swiperContainerElement
			)

			const swiperConfig = {
				navigation: {
					prevEl: findHtmlElement(
						'.js-slider-prev-btn',
						swiperContainerElement
					),
					nextEl: findHtmlElement(
						'.js-slider-next-btn',
						swiperContainerElement
					),
				},
			}

			initSwiper(swiperElement, swiperConfig)
		})
	})
}

const navListEl = findHtmlElement('.js-nav-list')
const toggleBtn = findHtmlElement('.js-toggle-btn')
if (toggleBtn) new Toggle(toggleBtn, { target: navListEl, toggleClass: 'hide' })

// Скрипт потрібен, щоб визначати, які елементи TOC (Table of Contents) потрібно стилізувати по-особливому.
// Ми дивимось на тег заголовка (h2, h3 і т.д.), з яким зв’язаний пункт TOC і додаємо до цього пункту спеціальний клас.
// Якщо всі заголовки мають однаковий тег, то стилі не додаються

// Збираємо всі елементи, що мають атрибут data-title (це заголовки h2, h3)
const titleElements = document.querySelectorAll('[data-title]')

const TITLE_CLASSES = {
	H2: 'nav-item-level-1',
	H3: 'nav-item-level-2',
}

// Перевіряємо, що є хоча б один заголовок і список навігації (ul) існує
if (titleElements.length && navListEl) {
	const tagsSet = new Set()
	const titlesInfo = []

	// Спочатку треба пройтись по елементам, отримати tag і id => додати в масив
	titleElements.forEach(title => {
		const tag = title.tagName
		if (!TITLE_CLASSES[tag]) return

		const titleId = title.getAttribute('id')
		if (!titleId) return
		tagsSet.add(tag)

		// Екрануємо id для безпечного використання у CSS-селекторі
		const safeId = CSS.escape(titleId)

		titlesInfo.push({ tag, safeId })
	})

	// Якщо є 2+ різних тега в titleElements - шукаємо елемент і додаємо стилі
	if (tagsSet.size > 1) {
		// Проходимось по масиву з обʼєктами в яких є tag і id
		titlesInfo.forEach(item => {
			// Шукаємо у списку TOC відповідне <a> по href="#id"
			const tocLink = navListEl.querySelector(`a[href='#${item.safeId}']`)
			if (!tocLink) return

			// Беремо батьківський елемент <li>, бо саме його треба стилізувати
			const tocParentEl = tocLink.parentElement
			if (!tocParentEl) return

			tocParentEl.classList.add(TITLE_CLASSES[item.tag])
		})
	}
}

const hotelSliders = document.querySelectorAll('.js-slider-hotels')
if (hotelSliders.length && titleElements.length) {
	// Ці ID ОБОВʼЯЗКОВО повинні === ID елементів $hotelGroups на сторінці from-parsed-page_1.blade.php
	const sectionInfo = [
		{
			sectionId: 'js-slider-hotels-all',
			isMainSwiper: true,
		},
		{
			sectionId: 'js-slider-hotels-all-reversed',
			isMainSwiper: false,
		},
	]

	renderCategorySliders(titleElements, TITLE_CLASSES, sectionInfo)
}
